// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3V_P9","header":"PatientBlock_header__APpDB","label":"PatientBlock_label__2gsN9","option":"PatientBlock_option__2XSiw"};